"use strict";


var meterReader = require('@smartvatten/pointer-reader'),
  longPointers = require('@smartvatten/long-pointer-reader'),
  decimalBuilder = require('./build-decimals'),
  debugBuilder = require('./build-debug-data'),
  calculator = require('./calculate-value'),
  pointerFilter = require('./pointer-filter'),
  checkFlow = require('./check-flow');

function round4digits(val) {
  return Math.round(val * 10000) / 10000;
}

exports.analyzeImage = function(pixels, config, cb) {
  if (!config.decimals || !config.decimals.positions) {
    cb("decimals configuration error", null);
    return;
  }
  //select algorithm based on configuration, always default to meterReader
  var algorithm = meterReader;

  if (config.decimals.meterType && config.decimals.meterType === 2) {
    algorithm = longPointers;
  }
  try {
    algorithm.analyzeImage(pixels, config, function(err, result) {
      result.debug = debugBuilder.createDebug(result);
      if (!err) {
        pointerFilter.filter(result, config, function(err, result) {
          result.flow = checkFlow(config, result);
          if (!err) {
            //debugBuilder.createSettingsString(result, config);
            var decimalsValue = decimalBuilder.build(result, config);
            result.rawPointerValue = decimalsValue;
            var ret = calculator.get(decimalsValue, config.previousPointerValue, config, result);
            if (!ret.err) {
              result.value = ret.res;
              result.precision = ret.precision;
              //result.debugData = "Meter value:"+ ret.res + " " + result.debugData;
            } else {
              err = ret.err + ' value found:' + decimalsValue;
            }
          }
          cb(err, result);
        });
      } else cb(err, result);
    });
  } catch (err) {
    cb(err, {});
  }
}




//////////////////
// WEBPACK FOOTER
// ./~/@smartvatten/flowone-algorithms/decimalpointers/index.js
// module id = 836
// module chunks = 0